import { render, staticRenderFns } from "./pcardgame.vue?vue&type=template&id=77753d3c&scoped=true&"
import script from "./pcardgame.vue?vue&type=script&lang=js&"
export * from "./pcardgame.vue?vue&type=script&lang=js&"
import style0 from "./pcardgame.vue?vue&type=style&index=0&id=77753d3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77753d3c",
  null
  
)

export default component.exports